import React from 'react';
import times from 'lodash/times';
import Row from 'app/shared/core/Row';
import Section from 'app/shared/modules/Section';
import SkeletonTitle from 'app/shared/modules/skeleton/SkeletonTitle';
import Container from 'app/shared/core/Container';
import { StyledSkeletonStatePage, StyledSkeletonStatePageCards } from './styles';
import SkeletonAreaCard from 'app/shared/modules/skeleton/SkeletonAreaCard';

class SkeletonStatePage extends React.Component {
  renderCards = (count: number) => {
    return times(count, (n) => {
      return <SkeletonAreaCard key={n} />;
    });
  };

  render() {
    return (
      <StyledSkeletonStatePage>
        <Container>
          <SkeletonTitle />
          <SkeletonTitle />

          <Section>
            <Row>
              <SkeletonTitle width="20%" />
            </Row>

            <StyledSkeletonStatePageCards>{this.renderCards(3)}</StyledSkeletonStatePageCards>
          </Section>
          <Section>
            <Row>
              <SkeletonTitle width="25%" />
            </Row>

            <div className="SkeletonStatePage-cards">{this.renderCards(3)}</div>
          </Section>
          <Section>
            <Row>
              <SkeletonTitle width="28%" />
            </Row>

            <div className="SkeletonStatePage-cards">{this.renderCards(3)}</div>
          </Section>
        </Container>
      </StyledSkeletonStatePage>
    );
  }
}

export default SkeletonStatePage;
